jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
	searchGenderSelectPage: {
		init: function () {
			this.tracking.trackPageView();
			const searchGenderForm = document.querySelector('#changeSearchGenderForm');

			if (searchGenderForm.querySelector('input[name="selectedGenders"]:checked')) {
				document.querySelector('#nextButton').disabled = false;
				document.querySelector('.infoText').classList.remove('noDisplay');
			}
			searchGenderForm.querySelectorAll('input[name="selectedGenders"]').forEach((el) => {
				el.addEventListener('click', (ev) => {
					const hasNoGenderSelected = searchGenderForm.querySelectorAll('input[name="selectedGenders"]:checked').length === 0;
					document.querySelector('#nextButton').disabled = hasNoGenderSelected;
					document.querySelector('.infoText').classList.remove('noDisplay');
					this.tracking.trackSearchGenderChange(ev.currentTarget.value);
				});
			});

			searchGenderForm.addEventListener('submit', (ev) => {
				ev.preventDefault();
				const selectedGendersList = Array.from(searchGenderForm.querySelectorAll('input'))
					.map((input) => (input.checked ? input.value : null))
					.filter((el) => el !== null);
				const formData = new URLSearchParams({ selectedGenders: selectedGendersList, _csrf: jPar.wdk.security.csrf.getToken() });

				fetch(searchGenderForm.action, {
					// Fetch instead of fetchIt because we need the raw response
					method: 'POST',
					body: formData,
					headers: {
						'X-CSRF-TOKEN': jPar.wdk.security.csrf.getToken(),
						'x-requested-with': 'XMLHttpRequest',
						'Content-Type': 'application/x-www-form-urlencoded',
					},
				}).then((response) => {
					if (response.redirected) {
						window.location.href = response.url;
					}
				});
			});
		},
		tracking: {
			trackPageView: function () {
				jPar.util.log.bigData({
					category: 'registration',
					subcategory: 'search_gender_select_screen',
					action: 'screen_view',
				});
			},

			trackSearchGenderChange: function (value) {
				let targetId = '';
				switch (value) {
					case 'MALE':
						targetId = 'button_man';
						break;
					case 'FEMALE':
						targetId = 'button_woman';
						break;
					case 'DIVERSE':
						targetId = 'button_nonbinary';
						break;
				}

				jPar.util.log.bigData({
					category: 'registration',
					subcategory: 'search_gender_select_screen',
					action: 'click',
					targetId: targetId,
				});
			},
		},
	},
});
